import React from 'react';
import { CiUser } from 'react-icons/ci';
import { FaRegFileAlt } from 'react-icons/fa';
import { PiRepeatFill } from 'react-icons/pi';
import { AiOutlineClockCircle } from 'react-icons/ai';

interface FilterPanelProps {
  filterValues: {
    customerName: string;
    articleNo: string;
    status: string;
    createdFrom: string;
    createdTo: string;
  };
  onFilterChange: (field: string, value: string) => void;
  statusOptions?: Array<{ value: string; label: string; color?: string }>;
  className?: string;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  filterValues,
  onFilterChange,
  statusOptions = [
    { value: 'All', label: 'All' },
    { value: 'HOLD', label: 'On Hold', color: 'rgb(255 237 213)' },
  ],
  className = '',
}) => {
  return (
    <div
      className={`bg-white p-6 rounded-xl shadow-md border border-gray-100 transition-all duration-300 ease-in-out ${className}`}
    >
      <div className="flex items-center divide-x divide-gray-300">
        {/* Company Name */}
        <div className="px-4 w-1/5">
          <label className="block text-sm font-bold text-gray-700">Company Name</label>
          <div className="relative rounded-md shadow-sm mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <CiUser className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search customer"
              className="block w-full pl-10 pr-3 py-2 bg-gray-50 border-none rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              value={filterValues.customerName}
              onChange={e => onFilterChange('customerName', e.target.value)}
            />
          </div>
        </div>

        {/* Article No */}
        <div className="px-4 w-1/5">
          <label className="block text-sm font-bold text-gray-700">Article No</label>
          <div className="relative rounded-md shadow-sm mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaRegFileAlt className="h-4 w-4 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Enter article number"
              className="block w-full pl-10 pr-3 py-2 bg-gray-50 border-none rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              value={filterValues.articleNo}
              onChange={e => onFilterChange('articleNo', e.target.value)}
            />
          </div>
        </div>

        {/* Status */}
        <div className="px-4 w-1/5">
          <label className="block text-sm font-bold text-gray-700">Status</label>
          <div className="relative rounded-md shadow-sm mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <PiRepeatFill className="h-4 w-4 text-gray-400" />
            </div>
            <select
              className="block w-full pl-10 pr-8 py-2 bg-gray-50 border-none rounded-md appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              value={filterValues.status}
              onChange={e => onFilterChange('status', e.target.value)}
            >
              {statusOptions.map(option => (
                <option
                  key={option.value}
                  value={option.value}
                  style={option.color ? { backgroundColor: option.color } : {}}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Created From */}
        <div className="px-4 w-1/5">
          <label className="block text-sm font-bold text-gray-700">Created From</label>
          <div className="relative rounded-md shadow-sm mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <AiOutlineClockCircle className="h-4 w-4 text-gray-400 opacity-70" />
            </div>
            <input
              type="date"
              placeholder="From"
              className="block w-full pl-10 pr-3 py-2 bg-gray-50 border-none rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm appearance-none text-gray-500"
              style={{
                backgroundImage: 'none',
                colorScheme: 'light',
                caretColor: 'transparent',
              }}
              value={filterValues.createdFrom}
              onChange={e => onFilterChange('createdFrom', e.target.value)}
            />
          </div>
        </div>

        {/* Created To */}
        <div className="px-4 w-1/5">
          <label className="block text-sm font-bold text-gray-700">Created To</label>
          <div className="relative rounded-md shadow-sm mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <AiOutlineClockCircle className="h-4 w-4 text-gray-400 opacity-70" />
            </div>
            <input
              type="date"
              placeholder="To"
              className="block w-full pl-10 pr-3 py-2 bg-gray-50 border-none rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm appearance-none text-gray-500"
              style={{
                backgroundImage: 'none',
                colorScheme: 'light',
                caretColor: 'transparent',
              }}
              value={filterValues.createdTo}
              onChange={e => onFilterChange('createdTo', e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
